module.exports = __webpack_public_path__ + "img/7aa0bbcf2f08679465ee3c8907b72441.62772860.jpg";